import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Header() {
  const { pathname } = useLocation();

  const [openMenu, setOpenMenu] = useState<boolean>(false);

  const [openSubMenuKey, setOpenSubMenuKey] = useState<string | null>(null);

  const [productSubMenuOpen, setProductSubmenuOpen] = useState(false);

  useEffect(() => {
    if (openMenu) {
      document.body.classList.add("mobile-nav-active");
    }
  }, [openMenu]);

  useEffect(() => {
    setOpenMenu(false);
    setOpenSubMenuKey(null);
    document.body.classList.remove("mobile-nav-active");
  }, [pathname]);

  return (
    <header id="header" className="header d-flex align-items-center fixed-top">
      <div className="container position-relative d-flex align-items-center justify-content-between">
        <Link to="/" className="logo d-flex align-items-center me-auto me-xl-0">
          <h1 className="sitename">
            <img src="/assets/images/logo.webp" alt="/assets/images/logo.webp" />
          </h1>
        </Link>

        <nav id="navmenu" className="navmenu">
          <ul>
            <li>
              <Link to="/" className={pathname === "/" ? "active" : ""}>
                HOME
              </Link>
            </li>
            <li className="dropdown">
              <Link
                to=""
                className={
                  pathname.startsWith("/about") ||
                    pathname === "/exhibition" ||
                    openSubMenuKey === "about"
                    ? "active"
                    : ""
                }
              >
                <span>ABOUT</span>
                <i
                  className={`bi ${openSubMenuKey === "about"
                    ? "bi-chevron-up"
                    : "bi-chevron-down"
                    } toggle-dropdown`}
                  onClick={() =>
                    setOpenSubMenuKey(
                      openSubMenuKey === "about" ? null : "about"
                    )
                  }
                ></i>
              </Link>
              <ul
                className={openSubMenuKey === "about" ? "dropdown-active" : ""}
              >
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/exhibition">Exhibition</Link>
                </li>
              </ul>
            </li>

            <li className="dropdown">
              <Link
                to=""
                className={
                  pathname.startsWith("/product") ||
                    pathname === "/glass" ||
                    openSubMenuKey === "product-page"
                    ? "active"
                    : ""
                }
              >
                <span>PRODUCTS</span>
                <i
                  className={`bi ${openSubMenuKey === "product-page"
                    ? "bi-chevron-up"
                    : "bi-chevron-down"
                    } toggle-dropdown`}
                  onClick={() =>
                    setOpenSubMenuKey(
                      openSubMenuKey === "product-page" ? null : "product-page"
                    )
                  }
                ></i>
              </Link>
              <ul
                className={
                  openSubMenuKey === "product-page" ? "dropdown-active" : ""
                }
              >
                <li className="dropdown">
                  <Link
                    to="/product"
                    className={productSubMenuOpen ? "active" : ""}
                    onClick={(e) => {
                      setProductSubmenuOpen(!productSubMenuOpen);
                    }}
                  >
                    WALTZ
                    <i
                      className={`bi ${productSubMenuOpen
                        ? "bi-chevron-down"
                        : "bi-chevron-right"
                        } toggle-dropdown`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setProductSubmenuOpen(!productSubMenuOpen);
                      }}
                    ></i>
                  </Link>

                  <ul className={productSubMenuOpen ? "dropdown-active" : ""}>
                    <li>
                      <Link to="/product/waltz/slide-nxt">WALTZ SLIDE NXT</Link>
                    </li>
                    <li>
                      <Link to="/product/waltz/glide-nxt">WALTZ GLIDE NXT</Link>
                    </li>
                    <li>
                      <Link to="/product/waltz/swing-nxt">WALTZ SWING</Link>
                    </li>
                    <li>
                      <Link to="/product/waltz/close-nxt">WALTZ CLOSE NXT</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/glass">GLASS</Link>
                </li>
                <li>
                  <Link to="/catalogues-download">CATALOGUES</Link>
                </li>
              </ul>
            </li>
            {/* <li>
              <Link to="/library">
                GALLERY
              </Link>
            </li> */}
            {/* <li>
              <Link to={"https://photos.jbglass.in/"} target="_blank">
                GALLERY
              </Link>
            </li> */}
            {/* <li>
              <Link to={"https://sample.jbglass.in/"} target="_blank">
                SAMPLES
              </Link>
            </li> */}
            <li>
              <Link to={"https://webapp2.jbglass.in/"} target="_blank">
                LOGIN
              </Link>
            </li>
            <li>
              <Link
                to="/contact-us"
                className={pathname === "/contact-us" ? "active" : ""}
              >
                CONTACT US
              </Link>
            </li>
          </ul>
          <i
            className={`mobile-nav-toggle d-xl-none bi ${openMenu ? "bi-x" : "bi-list"
              }`}
            onClick={() => {
              setOpenMenu(!openMenu);
              if (!openMenu) {
                document.body.classList.add("mobile-nav-active");
              } else {
                document.body.classList.remove("mobile-nav-active");
              }
            }}
          ></i>
        </nav>

        <div className="headerSocial">
          <ul>
            <li>
              <Link
                to={"https://www.facebook.com/jbglass.in?mibextid=ZbWKwL"}
                target="_blank"
              >
                <i className="fa fa-facebook"></i>
              </Link>
            </li>
            <li>
              <Link
                to={"https://instagram.com/jbglass_?igshid=YmMyMTA2M2Y="}
                target="_blank"
              >
                <i className="fa fa-instagram"></i>
              </Link>
            </li>
            <li>
              <Link to={"https://wa.me/+919999210073"} target="_blank">
                <i className="bi bi-whatsapp"></i>
              </Link>
            </li>
            <li>
              <Link to={"https://youtube.com/@jbglass7713"} target="_blank">
                <i className="fa fa-youtube-play"></i>
              </Link>
            </li>
            <li>
              <Link to={"https://twitter.com/JBGlass_"} target="_blank">
                <i className="bi bi-twitter-x"></i>
              </Link>
            </li>
            <li>
              <Link
                to={"https://www.linkedin.com/company/jbglass/"}
                target="_blank"
              >
                <i className="fa fa-linkedin"></i>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
